import React, { memo, useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ChevronArrowLeftIcon } from '../../../../assets/icons/ChevronArrowLeftIcon';
import { ChevronArrowRightIcon } from '../../../../assets/icons/ChevronArrowRightIcon';
import { getDaysInMonth } from '../../../../utils/CalendarUtils';
import { getMergedClassNames } from '../../../../utils/HTMLutils';
import { dateToString, stringToDate } from '../../../../utils/ParsingUtils';
import './DatePickerCalendar.scss';
const rootClassName = 'component-date-picker-calendar';

interface calendarProps {
  value?: string | null;
  disabled?: boolean;
  onChange?: (date: string) => void;
  language: {
    daysOfWeek: string[];
    months: string[];
    monthsAbrev: string[];
  };
}
function DatePickerCalendar(props: calendarProps) {
  const [today] = useState(new Date());
  const [month, setMonth] = useState(today.getMonth());
  const [year, setYear] = useState(today.getFullYear());

  useEffect(() => {
    if (props.value) {
      const d = stringToDate(props.value);
      if (d) {
        setMonth(d?.getMonth());
        setYear(d?.getFullYear());
      }
    } else {
      setMonth(today.getMonth());
      setYear(today.getFullYear());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  const [monthPage, setMonthPage] = useState(false);

  return (
    <div className={rootClassName}>
      <CSSTransition
        in={monthPage}
        classNames={`${rootClassName}-month-picker`}
        timeout={300}
        unmountOnExit
      >
        <div className={`${rootClassName}-month-picker`}>
          <div className='header'>
            <button
              className='prev'
              onClick={() => {
                setYear(year - 1);
              }}
            >
              <ChevronArrowLeftIcon />
            </button>
            <button className='month' disabled>
              {year}
            </button>
            <button
              className='next'
              onClick={() => {
                setYear(year + 1);
              }}
            >
              <ChevronArrowRightIcon />
            </button>
          </div>
          <div className={`${rootClassName}-months`}>
            {props.language.monthsAbrev.map((mes, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setMonth(index);
                    setMonthPage(false);
                  }}
                  className={getMergedClassNames([
                    `${rootClassName}-month`,
                    index === month ? 'selected' : '',
                  ])}
                >
                  {mes}
                </button>
              );
            })}
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={!monthPage}
        timeout={300}
        classNames={`${rootClassName}-bottom-page`}
      >
        <div className={`${rootClassName}-first-page`}>
          <div className='header'>
            <button
              className='prev'
              onClick={() => {
                if (month === 0) {
                  setYear(year - 1);
                  setMonth(11);
                } else {
                  setMonth(month - 1);
                }
              }}
            >
              <ChevronArrowLeftIcon />
            </button>
            <button
              className='month'
              onClick={() => setMonthPage(!monthPage)}
            >{`${props.language.months[month]} / ${year}`}</button>
            <button
              className='next'
              onClick={() => {
                if (month === 11) {
                  setYear(year + 1);
                  setMonth(0);
                } else {
                  setMonth(month + 1);
                }
              }}
            >
              <ChevronArrowRightIcon />
            </button>
          </div>
          <div className='week-days'>
            {props.language && props.language.daysOfWeek
              ? props.language.daysOfWeek.map((day, index) => {
                  return (
                    <div key={index} className='label'>
                      {day}
                    </div>
                  );
                })
              : undefined}
          </div>
          <div className='days'>
            {getDaysInMonth(month, year).map((day, index) => {
              return (
                <button
                  onClick={() => {
                    if (typeof props.onChange === 'function') {
                      props.onChange(dateToString(day));
                    }
                  }}
                  key={index}
                  className={getMergedClassNames([
                    'day',
                    day.getFullYear() === today.getFullYear() &&
                    day.getMonth() === today.getMonth() &&
                    day.getDate() === today.getDate()
                      ? 'today'
                      : '',
                    props.value &&
                    day.getFullYear() ===
                      stringToDate(props.value)?.getFullYear() &&
                    day.getMonth() === stringToDate(props.value)?.getMonth() &&
                    day.getDate() === stringToDate(props.value)?.getDate()
                      ? 'selected'
                      : '',
                  ])}
                  disabled={day.getMonth() !== month || props.disabled}
                >
                  {day.getDate()}
                </button>
              );
            })}
          </div>
        </div>
      </CSSTransition>
    </div>
  );
}

export default memo(DatePickerCalendar);
